import { useState, useEffect } from 'react';

import Image from 'next/image';

import { StyledMenu } from '../index.style';

const Sidebar = ({ catalogList, searchValue, selectedKeys, expandedKeys, onSelect, onExpand }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getParentKeys = (key) => {
      const parts = key.split('-');
      return parts.slice(0, -1).map((_, i) => parts.slice(0, i + 1).join('-'));
    };

    const processNode = (node) => {
      const strTitle = node.title.toString();
      const lowerSearch = searchValue.toLowerCase();
      const index = strTitle.toLowerCase().indexOf(lowerSearch);
      const isSelfMatched = index > -1;

      // 递归处理子节点
      const processedChildren = node.children?.map(processNode);
      const hasMatchedChild = processedChildren?.some((c) => c.isMatched) || false;
      const isMatched = isSelfMatched || hasMatchedChild;

      // 生成带高亮的标题
      const label =
        index > -1 ? (
          <span>
            {strTitle.substr(0, index)}
            <span style={{ color: '#f50' }}>{strTitle.substr(index, searchValue.length)}</span>
            {strTitle.substr(index + searchValue.length)}
          </span>
        ) : (
          strTitle
        );

      return {
        ...node,
        label,
        children: processedChildren?.filter((c) => c.isMatched),
        isMatched,
      };
    };

    // 处理数据并过滤
    const processedData = catalogList.map(processNode).filter((node) => node.isMatched);

    // 收集需要展开的父节点keys
    const expansionKeys = new Set();
    const collectKeys = (nodes) => {
      nodes.forEach((node) => {
        getParentKeys(node.key).forEach((k) => expansionKeys.add(k));
        if (node.children) collectKeys(node.children);
      });
    };
    collectKeys(processedData);
    setData(processedData);
    onExpand(searchValue ? [...expansionKeys] : [...expandedKeys]);
  }, [catalogList, searchValue]);

  const handleOpenChange = (keys) => {
    // 获取最新收起的菜单 key
    const latestClosedKey = expandedKeys.find((key) => !keys.includes(key));

    const latestClosedCatalog = catalogList.find((item) => item.key === latestClosedKey);

    // 一级菜单收起后移除其子级菜单的展开状态
    if (latestClosedCatalog) {
      const childKeys = latestClosedCatalog?.children?.map((item) => item.key) || [];
      const newKeys = keys.filter((key) => !childKeys.includes(key));
      onExpand(newKeys);
    } else {
      onExpand(keys);
    }
  };

  return (
    <>
      {data.length ? (
        <StyledMenu
          className="mt-[12px] pl-[5px]"
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={expandedKeys}
          onOpenChange={handleOpenChange}
          onSelect={onSelect}
          inlineIndent={10}
          items={data}
          expandIcon={({ isOpen }) => (
            <Image
              className={isOpen ? 'rotate-[90deg]' : ''}
              src="https://static.szlcsc.com/ecp/assets/newWeb/www/selection/arrow.svg"
              alt="展开图标"
              width={6}
              height={10}
            />
          )}
        />
      ) : (
        <div className="mt-[20px] text-center text-[#999]">暂无数据</div>
      )}
    </>
  );
};

export default Sidebar;
